import { isEmpty } from '@/utils';
import { CartItemModifier } from '@/domain/cart/types';
import { SIZE } from '@/domain/constants';

export const getSelectedModifiers = (
  modifiers: CartItemModifier, items: CartItemModifier[]
): void => {
  if (modifiers.type === SIZE) items.push(modifiers);

  modifiers?.modifiers?.forEach((item: CartItemModifier) => {
    if (isEmpty(item.modifiers)) items.push(item);

    getSelectedModifiers(item, items);
  });
};

export const getSelectedPizzaIngredient = (modifiers: CartItemModifier): CartItemModifier[] => {
  const items: CartItemModifier[] = [];

  getSelectedModifiers(modifiers, items);

  return items;
};
